module.exports = __webpack_public_path__ + "static/media/101088-kids-studying-from-home (1)a.f49be198.gif";